import { PartialMessage } from '@bufbuild/protobuf'
import { Media } from '@fingertip/creator-proto/gen/fingertip/common/type/v1/media_pb'
import { CSSProperties, ReactNode } from 'react'

import { DEFAULT_WIDTH } from '@/components/blocks/shared/constants'
import { MediaImage } from '@/components/blocks/shared/media-image'
import { cn } from '@/lib/utils'

type Props = {
  media?: PartialMessage<Media> | null
  className?: string
  style?: CSSProperties
  isPreview?: boolean
  children?: ReactNode
}

export const HeaderBanner = ({
  media,
  className,
  style,
  isPreview,
  children,
}: Props) => {
  const fallbackMedia = isPreview
    ? {
        type: 'UNSPLASH',
        color: '#8c8ca6',
        width: 3744,
        height: 5616,
        altText: 'a blurry photo of a blurry background',
        assetId: '',
        giphyId: '',
        assetSrc: '',
        giphyUrl: '',
        customUrl: '',
        unsplashId: 'NkQD-RHhbvY',
        assetBucket: '',
        unsplashUrl:
          'https://images.unsplash.com/photo-1519750783826-e2420f4d687f?ixid=M3w1MjM0MDF8MHwxfHNlYXJjaHwxOHx8YWJzdHJhY3QlMjBiYW5uZXJ8ZW58MHx8fHwxNzA5NjIwNjkxfDA&ixlib=rb-4.0.3',
        positionZoom: '',
        assetFileName: '',
        brandfetchUrl: '',
        giphySearchTerm: '',
        unsplashSearchTerm: 'abstract banner',
        brandfetchSearchTerm: '',
      }
    : null
  const newMedia = media || fallbackMedia

  if (!newMedia) {
    return null
  }

  return (
    <div
      className={cn('relative w-full overflow-hidden', className)}
      style={style}
    >
      {newMedia && (
        <MediaImage
          width={DEFAULT_WIDTH}
          height={DEFAULT_WIDTH}
          media={newMedia}
          priority={true}
          style={{ height: '100%', width: '100%' }}
        />
      )}

      {children}
    </div>
  )
}
